import { render } from "./AgentInputFileViewer.vue?vue&type=template&id=22f9ceb8&scoped=true"
import script from "./AgentInputFileViewer.vue?vue&type=script&lang=js"
export * from "./AgentInputFileViewer.vue?vue&type=script&lang=js"

import "./AgentInputFileViewer.vue?vue&type=style&index=0&id=22f9ceb8&scoped=true&lang=css"
import "./AgentInputFileViewer.vue?vue&type=style&index=1&id=22f9ceb8&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f9ceb8"]])

export default __exports__